import { inject } from '@angular/core';
import {
    patchState,
    signalStore,
    withMethods,
    withState,
} from '@ngrx/signals';

import { initialUiState } from './ui.state';
import { UIService } from './ui-service';
import { LoggerService } from '../logging/logger.service';

/**
 * This store manages the UI state using NgRx Signals.
 * It provides methods to interact with the UIService and update the state accordingly.
 * The store is initialized with the initial UI state and provides methods to handle UI-related actions.
 */
export const UIStore = signalStore(
    { providedIn: "root" },
    withState(initialUiState),
    withMethods((store) => {
        const uiService = inject(UIService);
        const logger = inject(LoggerService);
        return {
            toggleFeedbackFormVisibility() {
                const currentState = store.feedbackTemplateOpen;
                const newState = uiService.toggleFeedbackFormVisibility(currentState());
                patchState(store, { feedbackTemplateOpen: newState });
                logger.debug('UIStore', 'Feedback visibility updated', { open: newState });

            },
            initializeLanguage() {
                const selectedLanguage = uiService.initializeLanguage();
                patchState(store, { selectedLanguage });
                logger.debug('UIStore', 'Language state initialized', { selectedLanguage });
            },
            changeLanguage(language: 'de' | 'en') {
                uiService.changeLanguage(language);
                patchState(store, { selectedLanguage: language });
                logger.debug('UIStore', 'Language state updated', { language });
            }
        }
    })
)